import { render, staticRenderFns } from "./TourDetailsRating.vue?vue&type=template&id=66d48739"
import script from "./TourDetailsRating.js?vue&type=script&lang=js&external"
export * from "./TourDetailsRating.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports